import { Activity, Search, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function WarRoomEmptyState() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] p-12 text-center text-gray-300 relative overflow-hidden">
            {/* Background Grid Pattern */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] opacity-20 pointer-events-none" />

            <div className="relative z-10 max-w-2xl bg-black/40 backdrop-blur-md p-10 rounded-3xl border border-white/10 shadow-2xl">
                <div className="w-24 h-24 bg-blue-900/10 rounded-full flex items-center justify-center mb-6 mx-auto relative group">
                    <div className="absolute inset-0 bg-blue-500/20 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity" />
                    <Activity className="w-12 h-12 text-blue-500" />
                </div>

                <h2 className="text-4xl font-bold text-white mb-4 tracking-tight">War Room Inactive</h2>
                <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                    No high-priority targets have been identified for deep analysis.
                    <br />
                    <span className="text-sm text-gray-500 block mt-2">Initialize a contract from the search dashboard to activate this command center.</span>
                </p>

                <button
                    onClick={() => navigate('/search')}
                    className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-bold rounded-xl shadow-lg hover:shadow-blue-500/25 transition-all flex items-center gap-3 mx-auto group"
                >
                    <Search className="w-5 h-5" />
                    FIND TARGETS
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
            </div>
        </div>
    );
}
